import {
  CaretDownIcon,
  DividerHorizontalIcon,
  EraserIcon,
  FontBoldIcon,
  FontItalicIcon,
  HamburgerMenuIcon,
  ImageIcon,
  PlusIcon,
  QuoteIcon,
  ResetIcon,
  StrikethroughIcon,
  TextIcon,
  UnderlineIcon,
  UploadIcon,
} from '@radix-ui/react-icons';

import { Button } from '../../../primitives/button';
import { Separator } from '../../../primitives/separator';

import { Skeleton } from '../../../primitives/skeleton';
import { Toggle } from '../../../primitives/toggle';

export function EditorSkeleton() {
  return (
    <div className="rounded-lg border border-border">
      <div className="bg-muted/10">
        <Button aria-label="guardar documento" disabled variant="link">
          <UploadIcon className="size-4" />
          <span className="mt-[2px]">Guardar cambios</span>
        </Button>
      </div>
      <Separator />
      <div className="flex flex-wrap gap-1 p-2">
        <Button className="w-14 justify-between gap-0 rounded-full px-2" disabled variant="ghost">
          <TextIcon className="size-4" />
          <CaretDownIcon className="size-4" />
        </Button>
        <Button className="w-14 justify-between gap-0 rounded-full px-2" disabled variant="ghost">
          <div className="flex">
            <span className="w-[6px]" />
            <HamburgerMenuIcon className="size-4" />
          </div>
          <CaretDownIcon className="size-4" />
        </Button>
        <Button
          className="w-14 justify-between gap-0 rounded-full px-2 md:hidden"
          disabled
          variant="ghost"
        >
          <PlusIcon className="size-4" />
          <CaretDownIcon className="size-4" />
        </Button>
        <Separator className="hidden h-auto md:block" orientation="vertical" />
        <Toggle className="hidden md:block" disabled>
          <FontBoldIcon className="size-4" />
        </Toggle>
        <Toggle className="hidden md:block" disabled>
          <FontItalicIcon className="size-4" />
        </Toggle>
        <Toggle className="hidden md:block" disabled>
          <StrikethroughIcon className="size-4" />
        </Toggle>
        <Toggle className="hidden md:block" disabled>
          <UnderlineIcon className="size-4" />
        </Toggle>
        <Toggle className="hidden md:block" disabled>
          <QuoteIcon className="size-4" />
        </Toggle>
        <Button className="hidden md:block" disabled size="icon" variant="ghost">
          <ImageIcon className="size-4 text-success" />
        </Button>
        <Button className="hidden md:block" disabled size="icon" variant="ghost">
          <DividerHorizontalIcon className="size-4" />
        </Button>
        <Separator className="h-auto" orientation="vertical" />
        <Button disabled size="icon" variant="ghost">
          <EraserIcon className="text-red-150 size-4" />
        </Button>
        <div className="flex gap-1">
          <Button disabled size="icon" variant="ghost">
            <ResetIcon className="size-4" />
          </Button>
          <Button disabled size="icon" variant="ghost">
            <ResetIcon className="size-4 scale-x-[-1]" />
          </Button>
        </div>
      </div>
      <Separator />
      <div className="min-h-60 px-4 pt-8 pb-2">
        <div className="space-y-2">
          <Skeleton className="h-4 w-[20%]" />
          <Skeleton className="h-4 w-[30%]" />
        </div>
      </div>
      <p className="px-4 pb-2 text-end text-sm text-muted-foreground">
        0 caracteres
        <span className="mx-1 text-primary">|</span>0 palabras
        <span aria-label="emoji" className="ml-2" role="img">
          🤔
        </span>
      </p>
    </div>
  );
}
